import { useState, useEffect } from 'react';

import { _Labour } from '../../../../core/services/dataBean/EntityCatalog';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import Select from 'react-select';

interface Props {
    IDProductionRoute: number;
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectLabour = ({ idSelector, onChange, label, IDProductionRoute, returnType = "ID" }: Props) => {

    const { instance, lista, setLista } = useDataBean(_Labour)
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (IDProductionRoute) {
            getLista();
        }
    }, [IDProductionRoute]);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDLabour === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDLabour,
                    label: found.DataBeanProperties.Name,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        instance.getLabourCatalog(IDProductionRoute).then(
            (rta: any) => {
                const sortedList = rta.sort((a, b) => a.DataBeanProperties.IDLabour - b.DataBeanProperties.IDLabour);
                setLista(sortedList);
            }
        ).catch(
            err => { console.log(err) }
        )
    }
    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDLabour,
        label: item.DataBeanProperties.Name,
        item: item
    }));
    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Tipo de Labor"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un tipo de labor..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    )
}